import type { ReactNode } from 'react';

import useTotalBalance from '@/ui/hooks/use-total-balance.js';
import { cn } from '@/ui/utils/classnames.js';
import HeaderTitle from './header-title.js';
import BackButton from '../../back-button/index.js';
import FancyAmount, { FancyAmountSkeleton } from '../../fancy-amount/index.js';

type ResponsiveHeaderProps = {
  title: ReactNode;
  onlyTitle?: boolean;
  onBack?: () => void;
};

function ResponsiveHeader({
  title,
  onlyTitle = false,
  onBack,
}: ResponsiveHeaderProps) {
  const { value: totalBalance, loading: isTotalBalanceLoading } =
    useTotalBalance();

  return (
    <header className="flex flex-col p-6 md:gap-y-10 md:px-12 md:py-8">
      <div className={cn('hidden md:block', onlyTitle && 'md:invisible')}>
        {isTotalBalanceLoading ? (
          <FancyAmountSkeleton />
        ) : (
          <FancyAmount value={totalBalance.toDefaultNumber()} />
        )}
      </div>

      <div
        className={cn(
          'grid grid-cols-[1fr_auto_1fr] items-center md:grid-cols-[auto_1fr]',
          !onlyTitle && 'gap-x-4',
        )}
      >
        <BackButton
          onClick={onBack}
          className={cn(onlyTitle && 'invisible md:w-0')}
        />

        <HeaderTitle>{title}</HeaderTitle>
      </div>
    </header>
  );
}

export default ResponsiveHeader;
